import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useGetBranchesByOrganizationIdQuery } from '@app/api/Branches';
import { useGetPositionsByOrganizationIdQuery } from '@app/api/Positions';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

export const useOrganizationUsersFiltersEffect = () => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();

  const { showNotification } = useNotification();

  const [searchParams] = useSearchParams();
  const organizationId = Number(searchParams.get('id'));

  const { data: allBranches, error: branchesError } =
    useGetBranchesByOrganizationIdQuery({
      ActiveBranchId,
      organizationId,
    });
  const { data: allPositions, error: positionsError } =
    useGetPositionsByOrganizationIdQuery({
      ActiveBranchId,
      organizationId,
    });

  useEffect(() => {
    if (branchesError) {
      showNotification(handleCatchError(branchesError));
    }
  }, [branchesError, showNotification]);

  useEffect(() => {
    if (positionsError) {
      showNotification(handleCatchError(positionsError));
    }
  }, [positionsError, showNotification]);

  return { allBranches, allPositions };
};
